import { render, staticRenderFns } from "./Mediabox.vue?vue&type=template&id=f6ef20ae&"
import script from "./Mediabox.vue?vue&type=script&lang=js&"
export * from "./Mediabox.vue?vue&type=script&lang=js&"
import style0 from "./Mediabox.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports